// extracted by mini-css-extract-plugin
export default {"dialogContent":"BreadProviderDisclosures_dialogContent__CP5q6"};